import {Component, Mixins, Ref, Vue, Watch} from 'vue-property-decorator';
import ProductInquiryDataMixin from '@/components/product/ProductInquiryDataMixin';
import ProductListMallInfoMixin from '@/components/product/ProductListMallInfoMixin';
import {FilterDataType} from '@/types/product';
import {momentAdd, getDownToday} from '@/utils/dateUtils';
import {getProductsConfigurationsByAllMall, escapeHtml} from '@/utils/commonUtils';
import {gridModelToExcel} from '@/utils/ncp';
import {writeExcel} from '@/utils/excel';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';

@Component
export default class ProductInquiryMethodsMixin extends Mixins(ProductInquiryDataMixin, ProductListMallInfoMixin) {

  @Ref()
  protected readonly dateRangePickerRef!: PageDateRangePicker;

  @Watch('$route.query')
  private onQueryStringChanged(query): void {
    if (query.delayYn && query.delayYn === 'Y') {
      this.search(1, true);
    }
  }

  public get currentDateRange(): string {
    const selectVal: FilterDataType = this.filterDateData.find((data: FilterDataType): any => data.selected) || {
      value: '0',
      label: this.toI18n('BOARD_FAQ_TODAY'),
      selected: true
    };
    return selectVal.value;
  }

  public dateData: {startYmd: string; endYmd: string} = {
    startYmd: '',
    endYmd: this.today
  };
  public dateReceiveData = {...this.dateData};

  private setStartYmd(): void {
    if (this.dateReceiveData.endYmd) {
      Object.assign(this.dateData, {
        startYmd: momentAdd(this.dateReceiveData.endYmd, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
        endYmd: this.dateReceiveData.endYmd
      });
    } else {
      Object.assign(this.dateData, {
        startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
        endYmd: this.today
      });
    }

    this.dateReceiveData = {...this.dateData};
  }

  private setYmd(): void {
    this.dateData = {...this.dateReceiveData};
    if (this.currentDateRange === '0') {
      Object.assign(this.dateData, {
        startYmd: this.today,
        endYmd: this.today
      });
    } else if (this.currentDateRange === 'ALL') {
      Object.assign(this.dateData, {
        startYmd: '2000-01-01',
        endYmd: this.today
      });
    } else {
      this.setStartYmd();
    }
    this.dateReceiveData = {...this.dateData};
  }

  public setFilterUnSelected(): void {
    const oldIdx = this.filterDateData.findIndex((item: FilterDataType): any => item.selected);
    Vue.set(this.filterDateData, oldIdx, {...this.filterDateData[oldIdx], selected: false});
  }

  public dateFilterChange(idx: number): void {
    this.setFilterUnSelected();
    Vue.set(this.filterDateData, idx, {...this.filterDateData[idx], selected: true});

    // 퀵버튼을 클릭했을 때 종료일을 항상 오늘 기준으로 세팅
    this.dateReceiveData = {
      ...this.dateReceiveData,
      endYmd: this.today
    }

    this.setYmd();
  }

  public dateDataChange({startYmd, endYmd, isBtnSet}: any): void {
    if (!isBtnSet) {
      this.setFilterUnSelected();
      // 퀵버튼을 클릭하면 이벤트 실행 순서가 dateFilterChange -> dateDataChange 순서로 실행되기 때문에
      // 퀵버튼으로 날짜를 변경하여도 이전 날짜로 세팅되는 이슈가 있어 퀵버튼이 아닌 경우에만 dateReceiveData 를 갱신하도록 코드 옮김
      this.dateReceiveData = {startYmd, endYmd};
    }
    // 변경된 날짜로 업데이트를 하지 않으면, 수동으로 종료 일자를 선택 한 후, 오늘 버튼을 클릭하면 시작 일자가 변경되지 않음
    this.dateRangePickerRef.onDateObjectChange(this.dateReceiveData);
  }

  public girdOnClick({inquiryNo, member: {memberId, memberStatus} = {memberId: '', memberStatus: ''}, mallNo, admin, orderNo, mallProductNo}: any): void {
    this.repliedData = {};
    this.orderInfoData = Object.assign({});
    if (memberStatus) {
      this.$api.getProductInquiriesByInquiryNo({params: {inquiryNo}}).then(({data}: any): void => {
        this.repliedData = Object.assign({}, {...data, memberId, mallNo, memberStatus, admin});
      });
    }
    if (orderNo) {
      this.$api.getOrdersByOrderNo({params: {orderNo}}).then(({data: {shippings, orderProducts, orderer}}: any): void => {
        const orderProduct = orderProducts.find(product => product.mallProductNo === mallProductNo);
        this.orderInfoData = Object.assign({}, {...shippings[0], ...orderProduct, orderer});
      });
    } else {
      this.orderInfoData = Object.assign({});
    }
  }

  public fetchReplied({inquiryNo, member: {memberId, memberStatus}, mallNo, admin, orderNo}: any): void {
    this.girdOnClick({inquiryNo, member: {memberId, memberStatus}, mallNo, admin, orderNo});
  }

  public addDelayYn(): void {
    //     먼저, delay 조회 시, 검색 기간은 오늘 기준으로 3개월 이전 날짜로 기간을 변경해주셔야 하며
    // replyStatusType=READY로 변경해주셔야 합니다.
    this.dateFilterChange(3);
    this.searchParams.replyStatusType = 'READY';
    this.$router.push({name: 'ProductInquiryPrev', query: Object.assign({}, this.$route.query, {delayYn: 'Y'})}).catch((): void => {});
  }

  public fireExcelDown(): void {
    const params = {
      mallNo: this.searchParams.mallNo,
      searchDateType: this.searchParams.searchDateType,
      startYmd: this.dateReceiveData.startYmd,
      endYmd: this.dateReceiveData.endYmd,
      searchType: this.searchParams.searchType,
      keyword: this.searchParams.keyword,
      replyStatusType: this.searchParams.replyStatusType
    };
    this.$api.getProductInquiriesExcel({params}).then(({data}: any): void => {
      // this.searchRespones = Object.assign({}, data);
      const excelData = data;
      if (excelData.length === 0) {
        alert(this.$t('COMMON_NOT_DATA'));
      } else {
        if (excelData.length === 0) {
          alert(this.$t('COMMON_NOT_DATA'));
        } else {
          const model = gridModelToExcel(this.gridPropsExcel.columns);
          model.formatter['replied'] = ({value}: any): string => {
            return value ? this.toI18n('PRODUCT_INQUIRY_ANSWER_COMPLETED') : this.toI18n('PRODUCT_INQUIRY_WAITING_FOR_REPLY');
          };
          model.formatter['mallNo'] = ({row}: any): string => {
            return row.mallName;
          };
          model.formatter['mallProductNo'] = ({value}: any): string => {
            return value;
          };
          model.formatter['productName'] = ({value}: any): string => {
            return escapeHtml(value);
          };
          model.formatter['inquiryType'] = ({value}: any): string => {
            return this.inquiryType[value];
          };
          model.formatter['isSecret'] = ({value}: any): string => {
            return value ? this.toI18n('PRODUCT_INQUIRY_SECRET') : this.toI18n('PRODUCT_INQUIRY_NORMAL');
          };
          model.formatter['content'] = ({value}: any): string => {
            return value;
          };
          model.formatter['orderNo1'] = ({value}: any): string => {
            return value ? this.toI18n('PRODUCT_INQUIRY_PURCHASE') : this.toI18n('PRODUCT_INQUIRY_DO_NOT_PURCHASE');
          };
          model.formatter['partner'] = ({row: {partnerName}}: any): string => {
            return `${partnerName}`;
          };
          model.formatter['member'] = ({value, row: {registerNo}}: any): string => {
            if (!value) {
              return this.toI18n('PRODUCT_INQUIRY_WRONG_USER');
            }

            if (value.memberStatus === 'EXPELLED') {
              return this.toI18n('PRODUCT_INQUIRY_WITHDRAWAL_MEMBER');
            }

            return `${value.memberId} (${registerNo})`;
          };

          const excelColumn: any = {};
          this.gridPropsExcel.columns.forEach((column: any): void => {
            excelColumn[column.name] = column.header;
          });

          const filename = 'productInquiry_' + getDownToday();
          writeExcel(excelData, excelColumn, filename, model.formatter);
        }
      }
    });
    // const data = this.searchRespones.contents || [];
    // if (data.length === 0) {
    //   alert(this.$t('COMMON_NOT_DATA'));
    // } else {
    //   const model = gridModelToExcel(this.gridProps.columns);
    //   model.formatter['replied'] = ({value}: any): string => {
    //     return value ? this.toI18n('PRODUCT_INQUIRY_ANSWER_COMPLETED') : this.toI18n('PRODUCT_INQUIRY_WAITING_FOR_REPLY');
    //   };
    //   model.formatter['mallNo'] = ({row}: any): string => {
    //     return row.mall.mallName;
    //   };
    //   model.formatter['mallProductNo'] = ({value}: any): string => {
    //     return value;
    //   };
    //   model.formatter['productName'] = ({value}: any): string => {
    //     return escapeHtml(value);
    //   };
    //   model.formatter['inquiryType'] = ({value}: any): string => {
    //     return this.inquiryType[value];
    //   };
    //   model.formatter['isSecret'] = ({value}: any): string => {
    //     return value ? this.toI18n('PRODUCT_INQUIRY_SECRET') : this.toI18n('PRODUCT_INQUIRY_NORMAL');
    //   };
    //   model.formatter['content'] = ({value}: any): string => {
    //     return value;
    //   };
    //   model.formatter['orderNo'] = ({value}: any): string => {
    //     return value ? this.toI18n('PRODUCT_INQUIRY_PURCHASE') : this.toI18n('PRODUCT_INQUIRY_DO_NOT_PURCHASE');
    //   };
    //   model.formatter['partner'] = ({value}: any): string => {
    //     return value.partnerName;
    //   };
    //   model.formatter['member'] = ({value, row: {registerNo}}: any): string => {
    //     if (!value) {
    //       return this.toI18n('PRODUCT_INQUIRY_WRONG_USER');
    //     }

    //     if (value.memberStatus === 'EXPELLED') {
    //       return this.toI18n('PRODUCT_INQUIRY_WITHDRAWAL_MEMBER');
    //     }

    //     return `${value.memberId} (${registerNo})`;
    //   };

    //   const excelColumn: any = {};
    //   this.gridProps.columns.forEach((column: any): void => {
    //     excelColumn[column.name] = column.header;
    //   });

    //   const filename = 'productInquiry_' + getDownToday();
    //   writeExcel(data, excelColumn, filename, model.formatter);
    // }
  }

  public pageSizeChange(): void {
    this.$nextTick((): void => {
      this.search();
    });
  }

  public btnSearch(): void {
    this.$router.push({query: {delayYn: 'N'}}).catch((): void => {});
    this.search(1, false);
  }

  private prevSearchRequest = null; // FIXME : '엑셀 생성' 때 정합한 쿼리를 넘겨줄 오브젝트가 class 프로퍼티에 존재하지 않음에 따라 임시로 처리합니다.
  public search(page: number = 1, delayed: boolean = false): void {
    this.tableTitle = delayed ? this.toI18n('PRODUCT_INQUIRY_NUMBER_OF_INQUIRY_RESULTS') : this.toI18n('PRODUCT_INQUIRY_PRODUCT_INQUIRY_RESULT');
    const params = {};
    const startYmd = this.dateReceiveData.startYmd;
    const endYmd = this.dateReceiveData.endYmd;
    const isOfficeHour = delayed;
    this.searchParams.page = page;
    Object.assign(params, this.searchParams, {startYmd, endYmd, isOfficeHour});
    this.prevSearchRequest = params

    this.$api.getProductInquiries({params}).then(({data}: any): void => {
      this.searchRespones = Object.assign({}, data);
      this.gridProps.pageOptions.perPage = this.searchParams.size || 0;
      this.gridProps.pageOptions.page = page;
      this.gridProps.pageOptions.totalCount = data.totalCount;
    });
  }

  public setGrid(): void {
    this.searchRespones.contents.forEach((item, index): void => {
      $('td[data-column-name="radioBtn"][data-row-key="' + index + ')"]').height($('td[data-column-name="content"][data-row-key="' + index + '"]').height());
    });
  }

  public reset(): void {
    Object.assign(this.searchParams, {...this.searchParamsClone});
    this.dateFilterChange(2);
    this.setStartYmd();

    if (this.$route.query.delayYn) {
      this.$router.push({query: {delayYn: 'N'}}).catch((): void => {});
    }
  }

  public getTuiGrid(): any {
    return (this.$refs.gridArea as any).$refs.tuiGrid;
  }

  private async getCustomzitonColumns(): Promise<any> {
    const {data: gridCustomColumns} = await this.$api.getGridLayouts({params: {gridName: 'PRODUCT_INQUIRY_GRID'}});
    this.newColumnsCustomization = [];
    if (gridCustomColumns && gridCustomColumns.length) {
      gridCustomColumns.forEach(({columnName, visible}: any): void => {
        const column = this.gridProps.columns.find((item: any): boolean => item.name === columnName) as any;
        if (column && visible) {
          this.newColumnsCustomization.push(column);
        }
      });
    }

    const tuiGrid = this.getTuiGrid();
    if (this.newColumnsCustomization.length) {
      tuiGrid.invoke('setColumns', this.newColumnsCustomization);
    } else {
      tuiGrid.invoke('setColumns', this.gridProps.columns);
    }

    this.search();
  }

  public async created(): Promise<any> {
    if (this.$route.query.recentYn != null && this.$route.query.recentYn != undefined && this.$route.query.recentYn == 'Y') {
      this.dateFilterChange(5);
    }
    if(this.$route.query.mallNo && this.$route.query.memberId){
      this.searchParams.mallNo = this.$route.query.mallNo.toString();
      this.searchParams.keyword = this.$route.query.memberId.toString();
      this.searchParams.searchType = 'MEMBER_ID'
    }
    this.setStartYmd();
    this.$api.getProductInquiriesDelayedCount().then(({data}: any): void => {
      this.delayCount = data;
    });

    this.productDetailUrlObj = (await getProductsConfigurationsByAllMall()).map(({mallNo, productDetailUrl}: any): any => {
      return {[mallNo + '']: productDetailUrl};
    });

    if (this.malls && this.malls.length) {
      this.malls.splice(0, 1, {value: '0', label: this.toI18n('PRODUCT_INQUIRY_ALL')});
    }

    const delayed = this.delayed;
    this.tableTitle = delayed ? this.toI18n('PRODUCT_INQUIRY_NUMBER_OF_INQUIRY_RESULTS') : this.toI18n('PRODUCT_INQUIRY_PRODUCT_INQUIRY_RESULT');

    if (delayed) {
      this.dateFilterChange(3);
      this.searchParams.replyStatusType = 'READY';
    }

    this.getCustomzitonColumns();
  }
}
